import { useState } from "react";
import { Table, Card, Text, Button, Input, Badge } from "@nextui-org/react";
import { TbSearch, TbList, TbSortAscending } from "react-icons/tb";
import { Link } from "react-router-dom";

const columns = [
  { key: "_id", label: "City" },
  { key: "orders", label: "Orders" },
  { key: "products", label: "Products" },
  { key: "card", label: "Card" },
  { key: "cash", label: "Cash" },
  { key: "cashfree", label: "Cashfree" },
  { key: "ma", label: "Ma" },
  { key: "online", label: "Online" },
  { key: "udhar", label: "Udhar" },
  { key: "otherReplace", label: "Replace" },
  { key: "total", label: "Total" },
];

const ReportTable = (props) => {
  console.log(props);
  const [row, setRow] = useState(20);

  return (
    <Card variant="bordered" className="cardShadow">
      <Card.Header
        css={{
          display: "inline-flex",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        <Input
          aria-label="Set Row"
          contentLeft={<TbList />}
          type="number"
          bordered
          css={{ w: "100px" }}
          size="sm"
          value={row}
          onChange={(event) => setRow(event.target.value)}
        />
        <Input
          aria-label="Search"
          contentLeft={<TbSearch />}
          type="text"
          placeholder="Search..."
          bordered
          size="sm"
          value={props.value}
          onChange={(event) => props.setValue(event.target.value)}
          clearable
        />
      </Card.Header>
      <Card.Divider />
      <Card.Body css={{ p: 0 }}>
        <Table aria-label="Customers List" compact sticked shadow={false}>
          <Table.Header>
            {columns.map((column) => {
              return (
                <Table.Column key={column.key} css={{ color: "black" }}>
                  <div className="tableColumn">
                    {column.label}&nbsp;&nbsp;&nbsp;
                    {column.key !== "ctpin" && column.key !== "details" && (
                      <Button
                        auto
                        light
                        size="xs"
                        onClick={() =>
                          props.sortFunction(column.key, !props.asc)
                        }
                      >
                        <TbSortAscending />
                      </Button>
                    )}
                  </div>
                </Table.Column>
              );
            })}
          </Table.Header>
          <Table.Body css={{ textAlign: "start" }}>
            {props.list?.map((doc) => {
              return (
                <Table.Row
                  key={doc._id}
                  css={{
                    fontSize: "13px",
                  }}
                >
                  <Table.Cell>{doc._id}</Table.Cell>
                  <Table.Cell>{doc.orders?.length}</Table.Cell>
                  <Table.Cell>{doc.products}</Table.Cell>
                  <Table.Cell>
                    &#8377;{" "}
                    {(doc.card + doc?.otherCard)?.toLocaleString("en-in")}
                  </Table.Cell>
                  <Table.Cell>
                    &#8377;{" "}
                    {(doc.cash + doc?.otherCash)?.toLocaleString("en-in")}
                  </Table.Cell>
                  <Table.Cell>
                    &#8377;{" "}
                    {(doc.cashfree + (doc.otherCash ?? 0))?.toLocaleString(
                      "en-in"
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {" "}
                    &#8377; {(doc.ma + doc?.otherMa)?.toLocaleString("en-in")}
                  </Table.Cell>
                  <Table.Cell>
                    {" "}
                    &#8377; {doc.online?.toLocaleString("en-in")}
                  </Table.Cell>
                  <Table.Cell>
                    {" "}
                    &#8377;{" "}
                    {(doc.udhar + doc?.otherLoaned)?.toLocaleString("en-in")}
                  </Table.Cell>
                  <Table.Cell>
                    {" "}
                    &#8377; {doc.otherReplace?.toLocaleString("en-in")}
                  </Table.Cell>
                  <Table.Cell>
                    {" "}
                    &#8377; {doc.total?.toLocaleString("en-in")}
                  </Table.Cell>
                  {/* <Table.Cell>
                    <Link to={`/order/details/${doc.billno}`} target="_blank">
                      Details
                    </Link>
                  </Table.Cell> */}
                </Table.Row>
              );
            })}
          </Table.Body>
          <Table.Pagination
            size="sm"
            color="error"
            shadow
            align="center"
            rowsPerPage={row}
          />
        </Table>
      </Card.Body>
    </Card>
  );
};

export default ReportTable;
